import { Button, Modal } from '@shared/widgets';
import SuccessIcon from '@assets/images/auth/auth_success_ico.svg';

interface ISuccessfullyChangeYourPinModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SuccessfullyChangeYourPinModal = (props: ISuccessfullyChangeYourPinModalProps) => {
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      <SuccessIcon className='mx-auto mb-4 hidden max-md:block' />
      <p className='mb-9'>You have successfully changed the PIN of your card</p>
      <Button className='mx-auto w-[159px] max-md:w-full' onClick={props.onClose}>
        Ok
      </Button>
    </Modal>
  );
};
